/**
 * Add class helper method
 * @param {DOMelement} element - the element to add a class to
 * @param {String} className - the class to add
 * @return {DOMelement} element the original element
 */
const addClass = (element, className) => {
  if (element === null) {
    return element;
  }

  if (element.classList) {
    element.classList.add(className);
  } else {
    element.className += ` ${className}`;
  }

  return element;
};
export default addClass;
